import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Button, Overlay, Popover } from 'react-bootstrap';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';

class InvoiceCancelButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };

    this.buttonRef = React.createRef();
  }

  handleClick = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState(prevState => ({ show: !prevState.show }));
  };

  doClose = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ show: false });
  };

  doCancel = e => {
    e.preventDefault();
    e.stopPropagation();

    const { invoiceId, doCancel } = this.props;
    this.setState({ show: false });
    doCancel(invoiceId);
  };

  render() {
    const {
      intl: { messages },
      container,
      placement,
      formStatus,
    } = this.props;
    const { show } = this.state;

    return (
      <React.Fragment>
        <Button
          ref={this.buttonRef}
          bsSize="sm"
          bsStyle="danger"
          className="btn-rounded"
          onClick={this.handleClick}
          disabled={formStatus.pending}
        >
          <span className="hidden-xs">{messages.cancel_invoice}</span>
        </Button>

        <Overlay
          show={show}
          target={this.buttonRef.current}
          placement={placement}
          rootClose
          onHide={() => {
            this.setState({ show: false });
          }}
          container={container !== undefined ? container : undefined}
        >
          <Popover style={{ zIndex: 1200 }} id="invoice-cancel">
            <div className="text-center">{messages.are_you_sure}</div>

            <div style={{ width: '140px' }}>
              <Button block bsSize="sm" className="p-l-5 p-r-5 m-t-10" bsStyle="danger" onClick={this.doCancel}>
                {messages.cancel_invoice}
              </Button>
            </div>
          </Popover>
        </Overlay>
      </React.Fragment>
    );
  }
}
InvoiceCancelButton.defaultProps = {
  placement: 'top',
};

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.invoiceCancel,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doCancel: invoiceId => {
      formStatusDispatchHelper(
        'invoiceCancel',
        `/api/invoices/${invoiceId}/cancel.json`,
        { isCancelled: true },
        'put',
        dispatch
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(InvoiceCancelButton));
